const TOKEN_KEY = 'accessToken';
const REFRESH_TOKEN_KEY = 'refreshToken';

export const isToken = () => !!localStorage.getItem(TOKEN_KEY);

export const setToken = (token) => localStorage.setItem(TOKEN_KEY, token);

export const setRefreshToken = (token) => localStorage.setItem(REFRESH_TOKEN_KEY, token);

export const getToken = () => localStorage.getItem(TOKEN_KEY);

export const getRefreshToken = () => localStorage.getItem(REFRESH_TOKEN_KEY);

export const removeToken = () => localStorage.removeItem(TOKEN_KEY);

export const removeRefreshToken = () => localStorage.removeItem(REFRESH_TOKEN_KEY);
